import { useEffect, useState } from 'react';
import './ProgressBar.css';

interface ProgressBarProps {
  progress: number;
  message?: string;
  showPercentage?: boolean;
}

export function ProgressBar({ progress, message, showPercentage = true }: ProgressBarProps) {
  const [displayProgress, setDisplayProgress] = useState(0);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setDisplayProgress(progress);
    }, 50);

    return () => clearTimeout(timeout);
  }, [progress]);

  return (
    <div className="progress-container">
      {message && <div className="progress-message">{message}</div>}
      <div className="progress-bar-wrapper">
        <div
          className="progress-bar-fill"
          style={{ width: `${displayProgress}%` }}
        >
          {showPercentage && displayProgress > 10 && (
            <span className="progress-percentage">{displayProgress}%</span>
          )}
        </div>
        {showPercentage && displayProgress <= 10 && (
          <span className="progress-percentage-outside">{displayProgress}%</span>
        )}
      </div>
    </div>
  );
}
